
import Vue from 'vue'
import { accounts } from '@/assets/menu'
import MenuEntity, { IMenuProps } from '@/entities/Menu'

const component = Vue.extend({
  data() {
    return {
      accounts
    }
  },
  computed: {
    __accounts(): IMenuProps[] {
      return this.accounts.filter((prop) => {
        if (prop.id === 'account-superuser') {
          return this.App.doctor.entity.superuser
        } else if (prop.id === 'account-hospital') {
          return !this.App.doctor.entity.superuser && (this.App.doctor.current?.hospitals?.length || 1) > 1
        }
        return true
      })
    }
  },
  methods: {
    m(value: IMenuProps): MenuEntity {
      return new MenuEntity(value)
    }
  }
})

Vue.component('MAppAccount', component)
export default component
